import Button, * as Btn from '@lib/components/Button';
import ErrorMessage from '@lib/components/ErrorMessage';
import InputText, * as IInputText from '@lib/components/InputText';
import TitleBar, * as ITitleBar from '@lib/components/TitleBar';
import { SiteAddProps } from 'containers/SiteAdd';
import * as React from 'react';
import { IMAGE_PATH, isPairingCodeValid, isSiteNameValid } from 'util/util';
import './SiteAdd.css';






interface ISiteAddState {
  code: string;
  isCodeError: boolean;
  isNameError: boolean;
  name: string;
  modified: boolean;
}

class SiteAdd extends React.Component<SiteAddProps, ISiteAddState> {

  public constructor(props: SiteAddProps) {
    super(props);
    const regRes = window.location.href.match(/code=(.*)&/);
    this.state = {
      code: (regRes !== null && regRes.length > 0 ? regRes[1] : ''), isCodeError: false, isNameError: false, modified: false, name: ''
    };
  }

  /**
   * Fired when user clicks on "SiteAdd" button
   * @param state 
   * @param event 
   */
  public onAddSite(state: ISiteAddState, event: React.MouseEvent<HTMLDivElement>) {
    // Check values
    const isCodeError = !(isPairingCodeValid(this.state.code));
    const isNameError = !(isSiteNameValid(this.state.name));

    this.setState({ isCodeError, isNameError });

    if (isCodeError || isNameError) {
      return;
    }
    this.props.onSiteAdd(this.state.code, this.state.name);
  }


  /**
   * Fired when a user click on a camera
   * @param state 
   * @param event 
   */
  public onCameraClick(state: ISiteAddState, event: React.MouseEvent<HTMLDivElement>) {
    cordova.plugins.barcodeScanner.scan(
      (result: any) => {
        /*alert("We got a barcode\n" +
          "Result: " + result.text + "\n" +
          "Format: " + result.format + "\n" +
          "Cancelled: " + result.cancelled);*/
        if (/code=(.*)&/.test(result.text)) {
          const regRes = result.text.match(/code=(.*)&/);
          this.setState({ code: regRes[1] });
        }
      },
      (error: any) => {
        alert("Scanning failed: " + error);
      },
      {
        disableAnimations: true, // iOS
        disableSuccessBeep: false, // iOS and Android
        preferFrontCamera: false, // iOS and Android
        showFlipCameraButton: false, // iOS and Android
        showTorchButton: false, // iOS and Android
        torchOn: true,

        // saveHistory: true, // Android, save scan history (default false)
        // prompt: "Place a barcode inside the scan area", // Android
        // resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
        // formats: "QR_CODE,PDF_417", // default: all but PDF_417 and RSS_EXPANDED
        // orientation: "landscape", // Android only (portrait|landscape), default unset so it rotates with the device
        // torchOn: true, // Android, launch with the torch switched on (if available)
      }
    );
  }

  /**
   * Fired when user click on menu hamburger button
   * @param event 
   */
  public onMenuClick(event: React.MouseEvent<HTMLDivElement>) {
    if (!this.state.modified || confirm(this.props.i18n.Common.confirmCancel)) {
      window.location.hash = '/home';
    }
  }

  /**
   * Fired when user change code input field
   * Logins are louper cased to prevent error...
   * @param state 
   * @param event 
   */
  public onChangeCode(state: ISiteAddState, event: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ code: event.currentTarget.value.toLowerCase(), isCodeError: this.state.isCodeError && !isPairingCodeValid(event.currentTarget.value), modified: true, });
  }

  /**
   * Fired when user change code input field
   * Logins are louper cased to prevent error...
   * @param state 
   * @param event 
   */
  public onChangeName(state: ISiteAddState, event: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ modified: true, name: event.currentTarget.value, isNameError: this.state.isNameError && !isSiteNameValid(event.currentTarget.value) });
  }

  public render() {

    const i18n = this.props.i18n;

    return (
      <div className="standardPage">
        <TitleBar
          leftIcon={ITitleBar.ICO_CHEVRON_LEFT}
          onLeftButtonClick={this.onMenuClick.bind(this, this.state)}
          title={i18n.SiteAdd.title}
        />

        <div className="contentCentered">
          <div>
            <img className="siteAddIco" src={IMAGE_PATH + 'color3_100_desktop@3x.png'} />
            <InputText icon={IInputText.ICO_BARCODE} maxLength={30} type="text" required={true} name={i18n.SiteAdd.code} id="code" isError={this.state.isCodeError} error={i18n.SiteAdd.errorCode} value={this.state.code} onChange={this.onChangeCode.bind(this, this.state)} />
            <InputText icon={IInputText.ICO_FONT} type="text" required={true} name={i18n.SiteAdd.name} id="name" isError={this.state.isNameError} error={i18n.SiteAdd.errorName} value={this.state.name} onChange={this.onChangeName.bind(this, this.state)} />
            <ErrorMessage message={i18n.Common.errors[this.props.errorMessage]} />
          </div>
        </div>
        <div id="footerButton">
          {cordova.isFake !== true &&
            <Button labelFA='camera' type={Btn.BTN_TYPE_CIRCLE_UP} onClick={this.onCameraClick.bind(this, 'trash')} />
          }
          <Button labelFA='save' type={Btn.BTN_TYPE_CIRCLE} onClick={this.onAddSite.bind(this, -1)} />
        </div>
      </div>

    );
  }
}

export default SiteAdd;



// WEBPACK FOOTER //
// ./src/pages/SiteAdd.tsx